export enum FeedbackTypes {
  DISPLAY_PROBLEM,
  NOT_SOLVABLE_QUESTION,
  WRONG_FEEDBACK_OR_HINT,
  SPELLING_OR_TYPO,
  OTHER
}
